import request from '@/request/request'
let baseURL = global.$config.api.apiUrl + '/emergency-server/'
// 应急物资仓库列表-分页
export function warehouseList(query) {
  return request({
    baseURL,
    url: '/emergencyWarehouse/list',
    method: 'get',
    params: query
  })
}
// 应急物资仓库新增
export function warehouseSave(data) {
  return request({
    baseURL,
    url: '/emergencyWarehouse/save',
    method: 'post',
    data
  })
}
// 应急物资仓库修改
export function warehouseUpdate(data) {
  return request({
    baseURL,
    url: '/emergencyWarehouse/update',
    method: 'post',
    data: data
  })
}
// 应急物资仓库-详情
export function warehouseDetail(id) {
  return request({
    baseURL,
    url: '/emergencyWarehouse/detail?id=' + id,
    method: 'get'
  })
}
// 应急物资仓库-删除
export function warehouseRemove(data) {
  return request({
    baseURL,
    url: '/emergencyWarehouse/remove',
    method: 'post',
    data: { ...data, isFormData:true }
  })
}